import * as React from 'react';

function SvgMarkerIn(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={37} height={24} viewBox="0 0 37 24" {...props}>
      <rect width={37} height={24} opacity={0.5} rx={12} />
      <path fill="#FFF" d="M7 10.05h5V7l5 5-5 5v-3.05H7z" />
      <text
        fill="#FFF"
        fontFamily="Overpass-Bold, Overpass"
        fontSize={10}
        fontWeight="bold"
      >
        <tspan x={20.43} y={16}>
          {'IN'}
        </tspan>
      </text>
    </svg>
  );
}

export default SvgMarkerIn;
